<template>
  <main class="wrapper">
    <section class="banner">
      <div class="content">
        <a href="#" class="logo"><img src="@/assets/images/LandingLaboratory/Logo.svg" alt="onlineDoctor"></a>
        <img src="@/assets/images/LandingLaboratory/cloud.svg" class="cloud-img" alt="">
        <h1>Переведем ваши анализы с врачебного языка на разговорный</h1>
        <button @click="buttonHandler">Расшифровать анализы</button>
      </div>
    </section>
    <section class="questions">
      <div class="content content-m">
        <div class="blocks">
          <div class="block-item">
            <div class="message message--blue">
              <span>Что я получу</span>
              <span class="right">за 1000 руб?</span>
            </div>
          </div>
          <div class="separator line-1"></div>
          <div class="block-item two-img">
            <img src="@/assets/images/LandingLaboratory/doctor.png" alt="">
            <img src="@/assets/images/LandingLaboratory/file.svg" alt="">
            <p class="mr-43">Живую консультацию с врачом в любое время дня и ночи и письменное заключение после консультации</p>
          </div>
        </div>
        <div class="blocks" ref="middleBlock">
          <div class="block-item mr-112">
            <div class="message message--dark-blue">
              <span>А как проходит</span>
              <span class="right">консультация?</span>
            </div>
          </div>
          <div class="separator line-2"></div>
          <div class="block-item mr-74">
            <img src="@/assets/images/LandingLaboratory/options.svg" alt="">
            <p class="title mr-70">Выбирайте удобный вам способ</p>
            <p class="mr-28">Прямо на сайте врач позвонит вам по видео или напишет в чате, а ещё он может позвонить вам по телефону</p>
          </div>
        </div>
        <div class="blocks">
          <div class="block-item">
            <div class="message message--blue-s">
              <span class="center">Почему у вас?</span>
            </div>
          </div>
          <div class="separator line-3"></div>
          <div class="block-item">
            <p class="title mr-62">У нас есть 3 главных преимущества</p>
            <ul class="list">
              <li><strong>Быстро:</strong> C момента загрузки анализов до их расшифровки пройдет меньше 15 минут</li>
              <li><strong>Качественно:</strong> Наши врачи не только профессионалы, но и приятные в общении люди. Мы это контролируем</li>
              <li><strong>Удаленно:</strong> Вам не нужно никуда идти, достаточно иметь под рукой мобильный телефон или компьютер</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="plan-steps">
      <div class="content content-bottom">
        <div class="blocks">
          <div class="block-item">
            <div class="message message--white">
              <span>Хорошо.</span>
              <span>Что нужно сделать?</span>
            </div>
          </div>
          <div class="separator line-4"></div>
          <div class="block-item">
            <p class="title">4 простых шага:</p>
            <ul class="list-steps">
              <li><span>1</span>Загрузите ваши анализы в форму ниже</li>
              <li><span>2</span>Введите свой номер телефона и код из смс</li>
              <li><span>3</span>Напишите ФИО и дату рождения</li>
              <li><span>4</span>Оплатите консультацию<span class="price">1000 руб</span></li>
            </ul>
            <p class="finish">
              <img src="@/assets/images/LandingLaboratory/finish.svg" alt="">
              <span>После оплаты вы сразу окажетесь в чате консультации и сможете начать общение с врачом</span></p>
          </div>
        </div>
      </div>
    </section>
    <section class="steps" ref="block">
      <div class="content">
        <h4>Давайте начнём!</h4>
        <ul class="switcher">
          <li v-bind:class="{active: step >= 1}"></li>
          <li v-bind:class="{active: step >= 2}"></li>
          <li v-bind:class="{active: step == 3}"></li>
        </ul>
        <div class="slide-steps">
          <transition name="slide">
            <Step1 v-if="checkStep(1)" :attachments="attachments" @complete="setStep(2)"/>
            <Step2 v-if="checkStep(2)" :user="user" @complete="setStep(3)"/>
            <Step3 v-if="checkStep(3)" :user="user" :attachments="attachments"/>
          </transition>
        </div>
      </div>
    </section>
    <section class="follow">
      <div class="content">
        <h4>Остались вопросы?</h4>
        <p>Наша служба поддержки поможет вам круглосуточно 
          <span>по телефону <a href="tel:88003332800">8 800 333 28 00</a></span></p>
        <div class="follow-social">или в мессенджере
          <ul>
            <li><a href="https://t.me/online_doctor_bot" target="_blank"></a></li>
          </ul>
        </div>
      </div>
    </section>
    <footer>
      <div class="content">
        <div class="footer-block">
          <div class="top-block">
            <p>ООО &laquo;Мобильные Медицинские Технологии&raquo;</p>
            <p>Юр. адрес: 121205, г. Москва, Территория инновационного центра Сколково, ул. Нобеля, д. 7, ЭТ 1, ПОМ 175, РАБ 7.</p>
            <p>ОГРН: 1137746756883</p>
          </div>
          <div class="bottom-block">
            <p>Не является медицинской организацией.</p>
            <p>Консультации проводятся врачами медицинских организаций прикрепленных к сервису &laquo;Онлайн Доктор&raquo;, имеющие разрешения в установленном порядке.</p>
          </div>
        </div>
        <div class="footer-follow">
          <p>Техническая поддержка
            <a href="tel:88003332800">8 800 333 28 00</a>
          </p>
          <ul>
            <li class="vk"><a href="https://vk.com/onlinedoctor_ru" target="_blank"></a></li>
            <li class="inst"><a href="https://www.instagram.com/onlinedoctor.ru/?hl=ru" target="_blank"></a></li>
            <li class="tiktok"><a href="https://www.tiktok.com/@onlinedoctor.ru?lang=ru-RU" target="_blank"></a></li>
            <li class="teleg"><a href="https://t.me/online_doctor_bot" target="_blank"></a></li>
<!--            <li class="fb"><a href="https://www.facebook.com/onlinedoctor.ru" target="_blank"></a></li>-->
          </ul>
        </div>
      </div>
    </footer>
  </main>
</template>

<script>
  import Step1 from '../../components/Step1/Step1.vue'
  import Step2 from '../../components/Step2/Step2.vue'
  import Step3 from '../../components/Step3/Step3.vue'

  import './style.scss'

  import { bus } from '../../main'

  export default {
    name: 'LandingLaboratory',
    data() {
      return {
        step: 1,
        attachments: [],
        user: {},
        currentStep: 1,
      }
    },
    methods: {
      setStep(step) {
        this.currentStep = step;
        this.step = step;
      },
      checkStep(step) {
        return this.currentStep === step
      },
      setCurrentStep(step){
        if (step > this.step) {
          return
        }
        this.currentStep = step
      },
      buttonHandler() {
          this.scrollToBlock('block');
          bus.$emit('laboratoryLanding.analytics', {action: 'clickHeadCreateConsultationButton'});
      },
      scrollToBlock(toBlock) {
        const block = this.$refs[`${toBlock}`];
        const top = window.scrollY + block.getBoundingClientRect().y;
        window.scrollTo({
          top: top,
          behavior: 'smooth'
        })
      }
    },
    mounted(){
        const self = this;

        let middleBlockPassed = false;
        window.addEventListener("scroll", function () {
            if (middleBlockPassed) {
                return;
            }

            const elementTarget = self.$refs['middleBlock'];
            if (window.scrollY + (window.screen.availHeight / 2) > elementTarget.offsetTop) {
                middleBlockPassed = true;
                bus.$emit('laboratoryLanding.analytics', {action: 'scrollToMiddleBlock'});
            }
        });

        let blockPassed = false;
        window.addEventListener("scroll", function () {
            if (blockPassed) {
                return;
            }

            const elementTarget = self.$refs['block'];
            if (window.scrollY + (window.screen.availHeight / 2) > elementTarget.offsetTop) {
                blockPassed = true;
                bus.$emit('laboratoryLanding.analytics', {action: 'scrollToActionBlock'});
            }
        });
    },
    watch: {
        '$store.state.analyticsLoadedDone': function () {
            console.debug('analyticsLoadedDone');

            this.$store.commit('setAnalyticsLandingParameter', 'translater');

            this.$nextTick(function () {
                bus.$emit('laboratoryLanding.analytics', {action: 'init'});
            });

            setTimeout(function () {
                bus.$emit('laboratoryLanding.analytics', {action: '20sec'});
            }, 20000);
        }
    },
    components: {
      Step1,
      Step2,
      Step3
    }
  }
</script>

